// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--1-vt1","copyright":"footer-module--copyright--_WaUO"};